export default __webpack_public_path__ + "static/media/safari-icon.2d40e7cc.svg";